import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M20.3742 2.05783L7.87539 5.74906C7.62168 5.82876 7.39999 5.98731 7.24256 6.20165C7.08513 6.416 7.00016 6.67497 7 6.94092V17.1528C6.59068 17.0535 6.1712 17.0021 5.75 16.9997C3.67969 16.9997 2 18.1193 2 19.4999C2 20.8804 3.67969 22 5.75 22C7.82031 22 9.5 20.8804 9.5 19.4999V10.3712L19.5 7.44134V14.6531C19.0907 14.5534 18.6712 14.5019 18.25 14.4996C16.1797 14.4996 14.5 15.6192 14.5 16.9997C14.5 18.3803 16.1797 19.4999 18.25 19.4999C20.3203 19.4999 22 18.3806 22 16.9997V3.24891C21.9998 3.05266 21.9534 2.85922 21.8646 2.68423C21.7758 2.50924 21.647 2.35762 21.4887 2.24165C21.3304 2.12567 21.147 2.0486 20.9534 2.01666C20.7598 1.98473 20.5614 1.99883 20.3742 2.05783Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "Audio"
);
